// extracted by mini-css-extract-plugin
export var icon = "icon-module--icon--589c7";
export var isSmall = "icon-module--is-small--17cd1";